import { useConfig } from "@/config/ConfigContext";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Outlet } from "react-router-dom";

/**
 * Layout route that mounts the Google reCAPTCHA v3 provider once around the
 * auth route group. Keeping it as a parent layout (rather than inside an
 * individual page) means the reCAPTCHA script loads a single time and the
 * provider stays mounted while child routes swap via <Outlet />, preserving v3
 * behavioral context across auth-page navigation. The provider is intentionally
 * not an ancestor of private routes, so no reCAPTCHA script/telemetry runs on
 * the authenticated dashboard.
 *
 * Degrades gracefully: when no site key is configured we render the routes
 * without the provider (the login flow simply submits without a token).
 */
const RecaptchaLayout = () => {
  const { VITE_APP_RECAPTCHA_SITE_KEY } = useConfig();

  if (!VITE_APP_RECAPTCHA_SITE_KEY) {
    return <Outlet />;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={VITE_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{ async: true, defer: true, appendTo: "body" }}
    >
      <Outlet />
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaLayout;
